import React from 'react';
import PropTypes from 'prop-types';
import Panel from 'components/v2/panels/Panel';
import Button from 'components/v2/buttons/Button';
import classnames from 'classnames';
export default function CardFooter({ children, actionLabel, cancelLabel, className, onActionClick, onCancelClick, showCancelButton, }) {
    return (React.createElement(Panel, { className: classnames(className, 'bg-gray-50') },
        children,
        React.createElement("div", { className: "flex items-center justify-end space-x-4" },
            React.createElement(Button, { color: "green", onClick: onActionClick }, actionLabel),
            showCancelButton && (React.createElement(Button, { color: "", onClick: onCancelClick }, cancelLabel)))));
}
CardFooter.propTypes = {
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.array,
    ]),
    actionLabel: PropTypes.string,
    cancelLabel: PropTypes.string,
    onActionClick: PropTypes.func,
    onCancelClick: PropTypes.func,
    showCancelButton: PropTypes.bool,
};
CardFooter.defaultProps = {
    actionLabel: 'Save',
    cancelLabel: 'Cancel',
    showCancelButton: true,
};
